import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import CheckBoxGroup from "./CheckboxGroup";

/** A checkbox allows a user to make one or more selections from a set of options. */
const Checkbox = props => {
  const {
    id,
    name,
    label,
    value,
    checked,
    disabled,
    onChange,
    className,
    ...other
  } = props;

  return (
    <div
      className={clsx(
        "em-c-option-list__item",
        { "em-is-active": checked },
        className
      )}
      {...other}
    >
      <label className="em-c-input-group em-c-checkbox--container" htmlFor={id}>
        <input
          type="checkbox"
          name={name}
          id={id}
          value={value}
          checked={checked}
          onChange={e => {
            e.stopPropagation();
            onChange(!checked);
          }}
          disabled={disabled}
          className="em-c-input-group__control"
        />
        <span className="em-c-checkbox--checkmark" />
        <span className="em-c-input-group__text" htmlFor={id}>
          {label}
        </span>
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  /** Html Id, this should be filled out for accessibility */
  id: PropTypes.string,
  /** Html name, this should also be filled out for accessibility */
  name: PropTypes.string,
  /** label that will be shown next to the checkbox */
  label: PropTypes.node,
  /** Value of the selected checkbox, could be the same as the text or can be different */
  value: PropTypes.any.isRequired, //eslint-disable-line
  /** If the checkbox is checked or not */
  checked: PropTypes.bool,
  /** If the checkbox is disabled or not */
  disabled: PropTypes.bool,
  /** Function triggered by changes to the checkbox */
  onChange: PropTypes.func,
  /** Additional css classes to append to the outer element */
  className: PropTypes.string
};

Checkbox.defaultProps = {
  id: "",
  name: "",
  label: "",
  disabled: false,
  checked: false,
  onChange: () => {},
  className: ""
};

Checkbox.Group = CheckBoxGroup;

export default Checkbox;
